import { theme1 } from './theme1';
import { theme2 } from './theme2';

interface ThemeInterface {
  [key: string]: any;
}

const themes: ThemeInterface = { theme1, theme2 };

export { themes };
